import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import template from './OccurrenceNotesList.html?raw';
// NOTE (JS2TS): xstyle/css!./OccurrenceList.css was already commented out. Tabulator = runtime global; DOM-heavy → dom-construct aliased.
declare const Tabulator: any;
const domConstruct: any = domConstructTyped;

class OccurrenceNotesList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    occurrenceID: any = null;
    occurrence: any = null;
    _notes: any = [];

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(entitylist?: any): void {
        super.startup.apply(this, arguments as any);

        this.setNewButtonVisibility();

        if (typeof (entitylist) != "undefined") {
            domClass.remove(this.sectionNotes, "w3-hide");
            this._onLoadNotesResponse(entitylist);
        } else {
            this.loadNotes();
        }
    }

    setNewButtonVisibility(bOverrideBoolValue?: any): any {
        var actualValue = false;

        if (bOverrideBoolValue === true || bOverrideBoolValue === false) {
            actualValue = bOverrideBoolValue;
        } else if (this.occurrence != null) {
            actualValue = this.occurrence.canCreateNote == true;
        } else {

        }

        if (actualValue === true) {
            domClass.remove(this.btnNewNote, "w3-hide");
        } else {
            domClass.add(this.btnNewNote, "w3-hide");
        }

        return actualValue;
    }

    loadNotes(): void {
        domClass.add(this.sectionNotes, "w3-hide");

        this._notes = [];

        this.StandbyStart();

        var url = window.appRoot + "JDM/GetNotes";

        if (this.occurrenceID == null || typeof (this.occurrenceID) == "undefined") {
            this.StandbyStop();
            return;
        }

        domClass.remove(this.sectionNotes, "w3-hide");

        this.RequestManager.post(
            url,
            {
                occurrenceID: this.occurrenceID
            },
            lang.hitch(this, "_onLoadNotesResponse"),
            lang.hitch(this, "_onLoadNotesError"),
            false // sync
        );
    }



    _onLoadNotesResponse(notes: any): void {
        this.StandbyStop();

        //console.log("Notes loaded", notes);
        if (notes.length > 0) {
            domClass.remove(this.notesContainer, "w3-hide");
        } else {
            if (this.setNewButtonVisibility() === true) {
                domClass.add(this.notesContainer, "w3-hide");
            } else {
                domClass.remove(this.notesContainer, "w3-hide");
                domConstruct.empty(this.notesContainer);
                domConstruct.create("div", {
                    style: {
                        "fontStyle": "italic"
                    },
                    className: "w3-text-gray",
                    "innerHTML": this.translations["_general__noEntries"]//"keine Einträge"
                }, this.notesContainer);

                return;

            }
        }

        // employeeTasksContainer
        this.notesTable = new Tabulator(this.notesContainer, {
            data: notes,
            selectableCheck: lang.hitch(this, "tableSelectableCheck"),
            layout: "fitColumns",
            //height: "311px",
            columns: [
                {
                    title: this.translations["OccurrenceNotesList__TableCol_Date"]/*"Nummer"*/, field: "date_of_message", formatter: lang.hitch(this, "tableFormatterDateTime"), width: 130, editor: false
                },
                {
                    title: this.translations["OccurrenceNotesList__TableCol_Author"]/*"Aktionen"*/, field: "ref_employee.DispName", headerSort: false, width: 180
                },
                {
                    title: this.translations["OccurrenceNotesList__TableCol_Content"]/*"Status"*/, field: "message", editor: false, headerSort: false
                },
                {
                    title: ""/*Symbole*/, field: "ID", editor: false, headerSort: false, formatter: lang.hitch(this, this.tableFormatterSymbols), width: 30
                },


            ],
            rowFormatter: lang.hitch(this, this.rowFormatter),
        });

        domStyle.set(this.notesContainer, "fontSize", "12px");

    }

    rowFormatter(row: any): void {
        //row - row component

        var data = row.getData();

        if (data.is_private === true) {
            domClass.add(row.getElement(), "w3-yellow");
            for (let cell of row.getCells()) {
                domClass.add(cell.getElement(), "w3-yellow");
            }
        }
    }

    tableFormatterSymbols(cell: any): any {
        let data = cell.getRow().getData();
        console.log("notes formatter", data, cell, cell.getElement());

        let icons = "";

        if (data.is_private) {
            let icon = domConstruct.create("i", { "className": "fas fa-eye-slash", "title": this.translations["OccurrenceNote__IconPrivate"] });
            domAttr.set(cell.getElement(), "innerHTML", icon.outerHTML);
            icons += icon.outerHTML;
        }

        if (data.is_reading_confirmation) {
            let icon = domConstruct.create("i", { "className": "fas fa-check", "title": this.translations["OccurrenceNote__IconReadingConfirmation"] });
            domAttr.set(cell.getElement(), "innerHTML", icon.outerHTML);
            icons += icon.outerHTML;
        }

        return icons;
    }

    tableSelectableCheck(row: any): any {
        return false;
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any): any { //plain text value

        var data = cell.getRow().getData();
        var buttonStates = JSON.parse(data.tmp_buttonstates);

        var container = domConstruct.create("div");
        domClass.add(container, "flex_row");
        //console.log("tableBtnActions", data, buttonStates);

        //if (buttonStates.button_accept === true) {
        //    var button = domConstruct.create("div");
        //    domClass.add(button, "w3-padding-small mds-bg-gray mds-hover-dark zal-table-action-button");
        //    domAttr.set(button, "innerHTML", "<i class='fa fa-bolt'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Accept"] /*annehmen"*/);
        //    domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_AcceptTooltip"]);
        //    domConstruct.place(button, container);
        //    on(button, "click", lang.hitch(this, "_onClick__AcceptTask", data));
        //}


        return container;

    }

    tableFormatterDateTime(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        var date = new Date(value);

        //console.log("tableFormatterDateTime", data);

        if (value == "") {
            return "";
        }

        value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" } as any);

        return value;
    }


    _onLoadNotesError(error: any): void {
        this.StandbyStop();
    }


    _onClick_NewNote(): void {
        var dialog: any = new GenericDialog;

        domStyle.set(dialog.textNode, "height", "unset");
        dialog.destroyOnClose = false;

        dialog.set("header", this.translations["OccurrenceForm__DialogSendNoteHeader"].format(this.occurrence.Number));//taskEntity.Number + " erledigen");
        //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
        dialog.set("SubTitle", this.translations["OccurrenceForm__DialogSendNoteDescription"].format(this.occurrence.Number, this.occurrence.ref_reporter.DispName, this.occurrence.ref_executor_internal.DispName));

        dialog.set("ok", true);
        dialog.set("cancel", true);
        //dialog.set("content", "Hier Freitexteingabe");

        var input = domConstruct.create("textarea");
        domClass.add(input, "w3-input w3-block");
        dialog.addNodeToContent(input);

        dialog.addNodeToContent(this.sectionToResponsibleEmployee);
        dialog.addNodeToContent(this.sectionPrivateCb);

        //domAttr.set(input, "placeholder", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish_NotesPlaceholder"]);//"Anmerkungen?");

        //domAttr.set(input, "value", this.comment); // es sollte ein Standardtext irgendwoher kommen...

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(input, "keyup", function (evt: any) {
            evt.stopPropagation();
        });

        dialog.set("callback", lang.hitch(this, "_onSendNoteCallback", input, dialog));

        dialog.show();


        //console.log("cell mehrfachauswahl", cell, cellData, options);

        input.style.width = "100%";
    }

    _onSendNoteCallback(input: any, dialog: any, result: any): void {
        // Knoten retten!
        domConstruct.place(this.sectionPrivateCb, this.hiddenContainer);
        domConstruct.place(this.sectionToResponsibleEmployee, this.hiddenContainer);

        if (result != 1) {

            dialog.destroy();
            return;
        }

        this.StandbyStart();

        var note = input.value;
        var data = {
            message: note,
            occurrenceID: this.occurrence.ID,
            isForResponsibleEmployee: this.inputForResponsibleEmployee.checked == true,
            isInternalVisibility: this.cbPrivate.checked == true
        };


        var url = window.appRoot + "JDM/SendNote";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onSendNoteResponse", dialog),
            lang.hitch(this, "_onSendNoteError", dialog),
            false // sync
        );
    }
    _onSendNoteResponse(dialog: any): void {

        this.StandbyStop();
        dialog.destroy();

        this.loadNotes();
    }
    _onSendNoteError(dialog: any, error: any): void {
        alert(error.Message);
        this.StandbyStop();

        //domStyle.set(dialog.modalDlg, "display", "block");
        dialog.show();
    }


}
OccurrenceNotesList.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.OccurrenceNotesList';

export default mdsWidget(OccurrenceNotesList);
